export default function toString(x) {
  return x?.toString();
}